var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment__instrument injected",
      on: {
        click: function($event) {
          return _vm.start()
        }
      }
    },
    [
      !_vm.processing
        ? _c("div", { staticClass: "pi-item-wrapper" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/apay.svg"
                  ),
                  alt: "apay"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-info" }, [
                _c("div", { staticClass: "piitem-text-headline" }, [
                  _vm._v(_vm._s(_vm.$t("Payments.PNM.APay.Headline")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ios__info" }, [
                  _vm._v(_vm._s(_vm.$t("Payments.PNM.APay.Supported")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.APay.Desc")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "piitem-arrow" },
              [_c("v-icon", [_vm._v("chevron_right")])],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.processing
        ? _c("PNMGatewaySpinnerModal", { attrs: { type: _vm.type } })
        : _vm._e(),
      _vm._v(" "),
      _vm.redirectionUrl
        ? _c("PNMGatewayDialog", {
            ref: "pnmGatewayDialog",
            attrs: { redirectionUrl: _vm.redirectionUrl, type: _vm.type }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e4d7105", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4d7105","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/PayNearMeGateway/PNMAPay.vue
// module id = null
// module chunks = 